<template>
  <div v-if="!model.$disabled" class="custom-control custom-checkbox mb-3">
    <input
      :id="sid"
      ref="input"
      type="checkbox"
      class="custom-control-input"
      value="true"
      :aria-invalid="errorVisible"
      :aria-describedby="showError && errorVisible ? errId : undefined"
      :class="borderValidationClass"
      :checked="checked"
      :disabled="disabled"
      :name="model.$form.testPath ? model.$path : undefined"
      @change="onInput($event)"
      @focus="onFocus($event)"
      @blur="onBlur($event)"
    />

    <label class="custom-control-label" :for="sid">
      <slot>{{ getTitle }}</slot>
    </label>

    <w-error v-if="showError" :err-id="errId" :model="model" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';

export default {
  name: 'WCheckbox',
  components: { WError },
  mixins: [modelMixin, errorMixin('chk')],
  props: {
    uncheckvalue: {
      type: String
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    unvalue() {
      if (this.uncheckvalue === undefined) {
        if (this.value === 'true') {
          return 'false';
        } else if (this.value === 'on') {
          return 'off';
        } else {
          return false;
        }
      } else {
        return this.uncheckvalue;
      }
    },
    checked() {
      if (this.model.hasFocus) {
        return this.$options.localValue;
      }
      switch (this.model.$schema.type) {
        case 'boolean':
          return this.model.$value === 'true';
        case 'array':
          return this.model.$value.indexOf(this.value) > -1;
        default:
          return this.model.$value === this.value;
      }
    }
  },
  methods: {
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'true';
            break;
          case 'string':
            this.model.$value = this.value;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos === -1) {
              this.model.$addRow(this.$props.value);
            }
            break;
        }
      } else {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'false';
            break;
          case 'string':
            this.model.$value = this.unvalue;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos > -1) {
              this.model.$removeRow(pos);
            }
            break;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
